import React, { useState } from "react";
import Contacts from "@/pages/contacts";
import Employmentbasedgreencardimport from "@/pages/employmentbasedgreencardimport";
const Usastudyvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/usaimg.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
        </div>
      </div>
      <div className=" mt-10 w-full text-center text-3xl font-bold text-[#011473] drop-shadow-md md:ml-32 md:w-3/4 md:text-center">
        Study in the USA Visa
      </div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-4">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/studenta.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-6 lg:w-1/2">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="font-bold text-black"> F Visa: </a>For academic
              studies in accredited institutions (e.g., F1 visa).
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="font-bold text-black"> M Visa: </a>For non-academic
              or vocational training programs.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="font-bold text-black">J Visa:</a> For students in
              international exchange programs.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="font-bold text-black"> Requirements:</a> Acceptance
              letter from SEVP-certified institutions, Forms I-20 and DS-160.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="font-bold text-black"> Timeline:</a> Apply 120 days
              before I-20 start date; travel allowed 30 days prior.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 font-medium text-gray-700">
              <a className="font-bold text-black"> Oversight Bodies:</a>
              <ul className="list-disc pl-6">
                <li>U.S. Department of State (Consular Affairs, Embassies).</li>
                <li>
                  U.S. Department of Homeland Security (Study in the States).
                </li>
              </ul>
            </span>
          </div>
        </div>
      </div>
      <Employmentbasedgreencardimport />

      <div className="flex w-full flex-col items-center justify-center py-20">
        {isOpen && (
          <div className="mb-6 w-3/4 items-center justify-center rounded-md bg-gray-100 p-4 text-lg text-black shadow-md">
            <p>
              <br />
              <strong>Why Choose the USA for Your Studies?</strong>
              <br />
              <strong>Top-Notch Education System</strong>: Access over 4,000
              prestigious universities offering diverse programs.
              <br />
              <strong>Career Growth</strong>: Explore abundant career
              opportunities in various fields.
              <br />
              <strong>Flexible Learning</strong>: Benefit from adaptable and
              student-focused curriculums.
              <br />
              <strong>Research & Work Options</strong>: Engage in research with
              opportunities to work while studying.
              <br />
              <strong>Multicultural Environment</strong>: Experience a vibrant,
              inclusive atmosphere for international students.
              <br />
              <strong>Technological Advancements</strong>: Gain exposure to
              cutting-edge technologies, especially in science and engineering.
              <br />
              The USA offers international students a chance to pursue courses
              or participate in exchange programs through a temporary
              non-immigrant study visa. Apply today to be part of a globally
              renowned education system!
              <br />
            </p>
          </div>
        )}
        <button
          onClick={toggleAnswer}
          className="w-2/2 flex items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 md:w-1/2"
        >
          Learn About USA Study Visas
          <svg
            className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12l7 7 7-7"></path>
          </svg>
        </button>
      </div>

      <Contacts />
    </>
  );
};

export default Usastudyvisa;
